import axiosInstance from "@/utils/axios";


// ==================== CLINIC APIs ====================
export const addClinicApi = async (payload) => {
    const response = await axiosInstance.post('/api/clinics', payload);
    return response.data;
};

export const getClinicsApi = async (search = '',page) => {
    const params = {};
    if(search && search.trim()){
        params.search = search.trim();
    }
    
    const response = await axiosInstance.get(`/api/clinics?page=${page}`, {params});
    return response.data;
};

export const updateClinicApi = async ({ id, ...payload }) => {
    const response = await axiosInstance.put(`/api/clinics/${id}`, payload);
    return response.data;
};

export const StatusClinicApi = async (id) => {
    const response = await axiosInstance.get(`/api/clinics/status/${id}`);
    return response.data;
};

export const getClinicByIdApi = async (id) => {
    const response = await axiosInstance.get(`/api/clinics/${id}`);
    return response.data;
};
